// BSV CHANGES 
import { expenseReportsDownloadReducer } from '@app/screens/module-specific-utilities/pages/download-reports/redux';

type RootState = {
  expenseReportsDownload: ReturnType<typeof expenseReportsDownloadReducer>;
};

// ✅ Base selector to get the whole slice
export const expenseReportsStateSelector = (state: RootState) => state.expenseReportsDownload;

// ✅ Direct selectors for convenience
export const getExpenseReportsLoading = (state: RootState) =>
  expenseReportsStateSelector(state).loading;

export const getExpenseReportsData = (state: RootState) =>
  expenseReportsStateSelector(state).data;
